var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menu",class:{'active':_vm.isActive},attrs:{"id":"menu"},on:{"click":_vm.toggleMenu}},[_c('span',{staticClass:"bar"}),_c('span',{staticClass:"bar"}),_c('span',{staticClass:"bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }